// extracted by mini-css-extract-plugin
module.exports = {"row":"az_pbb"};